
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FounderStorySection from './components/FounderStorySection';
import ValuesSection from './components/ValuesSection';
import CommunityImpactSection from './components/CommunityImpactSection';
import AboutCTASection from './components/AboutCTASection';

const AboutPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <section className="py-20 bg-soft-gray">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="font-playfair text-5xl font-bold text-navy mb-6">
              About Legacy Business Acquisitions
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              We believe every business has a story worth preserving. Our mission is helping owners exit confidently while ensuring their legacy lives on through thoughtful stewardship of their people, customers, and reputation.
            </p>
          </div>
        </section>
        <FounderStorySection />
        <ValuesSection />
        <CommunityImpactSection />
        <AboutCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
